tasks-delivered-total
  span.delivered
    span.before { this.locale().before }
    span.badge.badge-primary    
      span.total(if="{isShowTotalBefore()}") { opts.total_before }
      span.and(if="{isShowDeliveredAndBefore()}") { this.locale().and }
      span.strings(if="{isShowStringsBefore()}") { opts.strings_before.join(', ') }
    span.theday-wrap(if="{ opts.theday != '' }")
      span.thedayis { this.locale().thedayis }
      span.badge.badge-primary
        span.theday { opts.theday }
  br
  span.planned
    span.planned-before { this.locale().planned_before }
    span.badge.badge-delivery    
      span.memo-total(if="{isShowMemoTotalBefore()}") { opts.memo_total_before }
      span.and(if="{isShowMemoAndBefore()}") { this.locale().and }
      span.memo-strings(if="{isShowMemoStringsBefore()}") { opts.memo_strings_before.join(', ')}
    span.theday-wrap(if="{ opts.memo_theday != '' }")
      span.thedayis { this.locale().thedayis }
      span.badge.badge-delivery
        span.theday { opts.memo_theday }
    span.planned-all { this.locale().planned_all }
    span.badge.badge-delivery
      span.memo-total(if="{isShowMemoTotal()}") { opts.memo_total }
      span.and(if="{isShowMemoAnd()}") { this.locale().and }
      span.memo-strings(if="{isShowMemoStrings()}") { opts.memo_strings.join(', ')}
  br
  span.required
    span.required-num { this.locale().required_num }
    span.badge.badge-warning
      span.data-total { opts.dataTotal }
  script(type="typescript").
    this.mixin('tasks.delivered-total')
  style(scoped).
    .badge {
      margin-left: .8rem;
      margin-right: .8rem;
    }
    .badge-delivery {
      background: rgb(93, 24, 81);
      color: #fff;
    }
    .and {
      font-size: .7em;
      display: inline-block;
      margin-left: .2rem;
      margin-right: .2rem;
    }
